export default function (value, regexString) {
  if (value === undefined || value === '' || value === null) return false

  const regex = new RegExp(regexString);

  return regex.test(value);
}